import { Component, Input } from '@angular/core';
import { TenantService } from '../../../core/services/tenant.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  @Input() logoUrl: string = ''
  @Input() logoWidth: string = '169px'
  @Input() logoHeight: string = '36px'
  currentYear = new Date().getFullYear()

  constructor() {}

  get logoStyle(): Record<string, string> {
    return {
      'background-image': `url('${this.logoUrl}')`,
      width: this.logoWidth,
      height: this.logoHeight,
    };
  }
}
